import styled, { keyframes, css } from "styled-components";
import { colors } from "../../../lib/colors";
import { BOARD_STYLED_PROPS } from "./interface";

const fadeInAnim = keyframes`
  0% {
     transform: scale(0.9);
     opacity:0;
     transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
  }
  100% {
    transform: scale(1);
    opacity:1;
   } 
`;
const fadeIn = css`
  ${fadeInAnim}
`;

export const CircleBox = styled.div<BOARD_STYLED_PROPS>`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  .circle {
    opacity: ${({ isWin }) => (isWin ? "1" : "0.8")};
  }
  p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  h3 {
    font-size: 10px;
    white-space: nowrap;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    margin-top: 10px;
    text-align: center;
    color: ${({ isWin }) =>
      isWin ? colors.secondary : colors.secondaryBackground};
    animation: ${fadeIn} 0.5s linear forwards;
    max-width: 56px;
    overflow: hidden;
  }
`;

export const BoardRow = styled.div<BOARD_STYLED_PROPS>`
  align-items: center;
  padding: 15px 0 34px;
  display: flex;
  justify-content: space-between;
  h3 {
    font-size: 12px;
    text-transform: uppercase;
    position: absolute;
    top: 100%;
    width: 100%;
    line-height: 2.33;
    text-align: center;
    color: ${colors.secondaryBackground};
    animation: ${fadeIn} 0.5s linear forwards;
  }
  .card {
    box-shadow: 0 2px 5px 0px rgba(0, 0, 0, 0.4);
  }
`;
export const GambleCircle = styled.div<BOARD_STYLED_PROPS>`
  position: relative;
  width: 56px;
  height: 56px;
  background: ${({ background }) => background};
  position: relative;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px;
  svg {
    width: 100%;
    height: 100%;
  }
`;
export const GambleAction = styled.div<BOARD_STYLED_PROPS>`
  background: ${({ background }) => background};
  border-radius: 50%;
  padding: 3px;
  border: solid 1px ${colors.primary};
  font-size: 10px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
`;
